import type {FetchResult} from '@apollo/client';

import {getGraphQLErrorCode} from 'lib/normalizeError';

function hasForbidden(errors: readonly unknown[] | undefined): boolean {
  return Boolean(
    errors?.some(
      (error) =>
        typeof error === 'object' && error !== null && getGraphQLErrorCode(error) === 'forbidden'
    )
  );
}

/** An Ash mutation refuses inside its payload: `{result: null, errors: [...]}`. */
function isRefusedPayload(payload: unknown): boolean {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }
  if (!('result' in payload) || !('errors' in payload)) {
    return false;
  }
  return payload.result === null && Array.isArray(payload.errors) && hasForbidden(payload.errors);
}

/** The answer to a request that arrived without its session: nothing, and `forbidden`. */
export function isSignedOutResult({data, errors}: FetchResult): boolean {
  if (data === null || data === undefined) {
    return hasForbidden(errors);
  }
  const fields = Object.values(data);
  if (fields.length === 0) {
    return false;
  }
  if (hasForbidden(errors)) {
    return fields.every((field) => field === null);
  }
  return fields.every(isRefusedPayload);
}
